import React, { useState } from "react";
import { ArtWorkDetailsProps } from "./types";
import { Avatar, AvatarGroup, Box } from "@mui/material";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { ArtWorkContainer, DetailsContainer, styles } from "./styles";
import { formatFileSize } from "../../services/trackService";
import { useNavigate } from "react-router-dom";
import { downloadSong } from "../TrackComponents/TrackHandler/trackHandlers";
import { handleCreateGroupChat } from "../TrackComponents/TrackHandler/trackHandlers";
import { TEXT_COLOR } from "../../theme";
import MessageIcon from "@mui/icons-material/Message";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { FileTrackLinkingModal } from "../Modal/FileTrackLinkingModal";
import LinkIcon from "@mui/icons-material/Link";

export const ArtWorkDetails: React.FC<ArtWorkDetailsProps> = ({
  fileDetails,
  user,
  fileSize,
  createdDate,
  setOpenCollabsModal,
  handleOpenDeleteModal,
  talkJsContext,
  setCreateGroupChatClicked,
}) => {
  const [isFileTrackLinkingModalOpen, setIsFileTrackLinkingModalOpen] =
    useState<boolean>(false);
  const navigate = useNavigate();

  const createGroupChat = (
    id: string | undefined,
    title: string | undefined
  ) => {
    handleCreateGroupChat(
      talkJsContext,
      fileDetails.getCollaboratorsList(),
      navigate,
      setCreateGroupChatClicked,
      id,
      title
    );
  };

  return (
    <>
      {isFileTrackLinkingModalOpen && (
        <FileTrackLinkingModal
          isFileTrackLinkingModalOpen={isFileTrackLinkingModalOpen}
          setIsFileTrackLinkingModalOpen={setIsFileTrackLinkingModalOpen}
          file={fileDetails}
        />
      )}
      <Box sx={styles.artworkMainContainer}>
        <ArtWorkContainer>
          <Box sx={styles.artworkImageContainer}>
            <img
              style={styles.artworkImage}
              src={fileDetails.getFileUrl()}
              alt="artwork"
            />
          </Box>
          <DetailsContainer>
            <Typography variant="h5" sx={styles.text}>
              {fileDetails?.getFilename()}
            </Typography>
            <Box sx={styles.typographyContainer}>
              <Typography sx={styles.text}>Owner:</Typography>
              <Typography>{user && user.getUsername()}</Typography>
            </Box>
            <Box sx={styles.typographyContainer}>
              <Typography sx={styles.text}>Label:</Typography>
              <Typography>{fileDetails?.getLabel()}</Typography>
            </Box>
            <Box sx={styles.typographyContainer}>
              <Typography sx={styles.text}>file Size:</Typography>
              <Typography>
                {fileSize ? formatFileSize(fileSize) : "-"}
              </Typography>
            </Box>
            <Box sx={styles.typographyContainer}>
              <Typography sx={styles.text}>Created Date:</Typography>
              <Typography>{createdDate}</Typography>
            </Box>
          </DetailsContainer>
          <DetailsContainer>
            <Box sx={styles.buttonsMainContainer}>
              <Box sx={{ display: "flex", gap: "10px" }}>
                <Tooltip title="Download" placement="bottom">
                  <IconButton
                    sx={{ paddingTop: "11px", color: "white" }}
                    onClick={() =>
                      downloadSong(
                        fileDetails.getFileUrl(),
                        fileDetails.getLabel()
                      )
                    }
                  >
                    <DownloadIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Add Collaborators" placement="bottom">
                  <IconButton
                    size="small"
                    onClick={() => {
                      setOpenCollabsModal(true);
                    }}
                  >
                    <ManageAccountsIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Link File With Tracks" placement="bottom">
                  <IconButton
                    sx={{ color: TEXT_COLOR }}
                    onClick={() => setIsFileTrackLinkingModalOpen(true)}
                  >
                    <LinkIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Message" placement="bottom">
                  <IconButton
                    sx={{ color: TEXT_COLOR }}
                    onClick={() => {
                      createGroupChat(
                        fileDetails.getId(),
                        fileDetails.getLabel()
                      );
                    }}
                  >
                    <MessageIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete" placement="bottom">
                  <IconButton
                    onClick={() => {
                      handleOpenDeleteModal(fileDetails.getId());
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
            <Typography sx={styles.text}>Collaborators:</Typography>
            <Box sx={styles.typographyContainer}>
              <AvatarGroup sx={{ display: "flex", gap: "5px" }}>
                {fileDetails?.getCollaboratorsList() &&
                  fileDetails
                    ?.getCollaboratorsList()
                    .filter((c: any) => c.getUsername())
                    .map((contributor: any) => {
                      return (
                        <Tooltip
                          key={contributor.getUsername()}
                          title={contributor.getUsername()}
                          placement="bottom"
                        >
                          <Avatar
                            style={styles.avatar}
                            src={
                              contributor.getProfilePicture()
                                ? contributor.getProfilePicture()
                                : "/broken-image.jpg"
                            }
                            onClickCapture={() => {
                              navigate(
                                `/user-profile/${contributor.getUsername()}`
                              );
                            }}
                            alt={contributor.getUsername()}
                          />
                        </Tooltip>
                      );
                    })}
              </AvatarGroup>
            </Box>
          </DetailsContainer>
        </ArtWorkContainer>
      </Box>
    </>
  );
};
